// extracted by mini-css-extract-plugin
export default {"bg-color":"pageContainer_bg-color__NHF36","page-container":"pageContainer_page-container__WREbi","page-container--wide":"pageContainer_page-container--wide__4RdWB"};